<script>
import TitleAndWelcome from '@/views/survey/edit/TitleAndWelcome'

export default {
  props:{
    surveyId: String
  },
  inject: ['isEdit'],
  render(h) {
    return h('div',
      {
        'class': {relative: true}
      },
      [
        h(TitleAndWelcome,{
          'class': {relative: true},
          attrs: {
            surveyId: this.surveyId
          }
        }),
        h('div',
          {
            'class': {mask: !this.isEdit}
          }
        )
      ]
    )
  }
}
</script>

<style lang="scss" scoped>
.mask{
  @apply absolute m-0 top-0 right-0 bottom-0 left-0 z-50;
}
</style>